import Button from 'components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
  ModalSheetTitle,
} from 'components/ModalSheet'
import ProDetails from 'iam/pro-details/ProDetails'
import { observer } from 'mobx-react'
import React from 'react'
import { EditProDetailsDialogViewModel } from './EditProDetailsDialogViewModel'

interface Props {
  vm: EditProDetailsDialogViewModel
}

const EditProDetailsDialog = observer(({ vm }: Props) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton bordered>
        <ModalSheetTitle>Edit Pro details</ModalSheetTitle>
      </ModalSheetHeader>

      <ModalSheetContent>
        <ModalSheetSection spaced>
          {vm.details && (
            <ProDetails vm={vm.details} showActions={false} />
          )}
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Cancel
          </Button>
          <Button
            submit
            type="primary"
            onClick={vm.submit}
            loading={vm.submit.pending}
            data-test="edit-pro-details-save-button"
          >
            Save
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default EditProDetailsDialog
